import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, Store, Stamp, Wrench, CarFront } from "lucide-react";

// Servicio pendiente «La Red» (flag enLaRedTodo). Markup original extraído de Navbar.js y Footer.js.
export const RedDesktopMenu = ({ transparent, ProdItem }) => {
  const [openRed, setOpenRed] = useState(false);
  const redRef = useRef(null);
  useEffect(() => {
    if (!openRed) return;
    const onDown = (e) => { if (redRef.current && !redRef.current.contains(e.target)) setOpenRed(false); };
    document.addEventListener("pointerdown", onDown);
    return () => document.removeEventListener("pointerdown", onDown);
  }, [openRed]);
  return (
    <div className="relative" ref={redRef} onMouseEnter={() => setOpenRed(true)} onMouseLeave={() => setOpenRed(false)}>
      <button
        onClick={() => setOpenRed(true)}
        className={`inline-flex items-center gap-1 ${transparent ? "text-white/80 hover:text-white" : "text-slate-600 hover:text-[#13315C]"}`}
        data-testid="nav-red-btn"
      >
        La Red <ChevronDown size={14} className={`transition-transform ${openRed ? "rotate-180" : ""}`} />
      </button>
      {openRed && (
        <div className="absolute left-0 top-full pt-2 w-[420px] z-50" data-testid="red-menu" onClick={() => setOpenRed(false)}>
          <div className="rounded-2xl border border-slate-200 bg-white shadow-2xl overflow-hidden">
            <ProdItem to="/vitrinas" icon={<Store size={18} />} title="Vitrinas de automotoras" desc="Catálogos verificados de autos en venta" testid="red-vitrinas" />
            <ProdItem to="/notarias" icon={<Stamp size={18} />} title="Red de notarías" desc="6+ notarías digitales · firma FEA en 72h" testid="red-notarias" />
            <ProdItem to="/talleres" icon={<Wrench size={18} />} title="Red de talleres asociados" desc="Servicios certificados con QR público" testid="red-talleres" />
            <ProdItem to="/automotoras" icon={<CarFront size={18} />} title="Para automotoras" desc="Inventario · retomas · vitrina pública" testid="red-automotoras" />
          </div>
        </div>
      )}
    </div>
  );
};

export const RedMobileSection = ({ closeMobile, MobileSection, MobileLink }) => (
  <MobileSection title="La Red" defaultOpen>
    <MobileLink to="/vitrinas" onClick={closeMobile} icon={<Store size={16} />} label="Vitrinas de automotoras" testid="mob-red-vitrinas" />
    <MobileLink to="/notarias" onClick={closeMobile} icon={<Stamp size={16} />} label="Red de notarías" testid="mob-red-notarias" />
    <MobileLink to="/talleres" onClick={closeMobile} icon={<Wrench size={16} />} label="Red de talleres" testid="mob-red-talleres" />
    <MobileLink to="/automotoras" onClick={closeMobile} icon={<CarFront size={16} />} label="Para automotoras" testid="mob-red-automotoras" />
  </MobileSection>
);

export const RedFooterColumn = () => (
  <div>
    <p className="tf-label text-white/50 mb-4">La Red</p>
    <ul className="space-y-2.5 text-sm">
      <li><Link to="/vitrinas" className="hover:text-white">Vitrinas</Link></li>
      <li><Link to="/notarias" className="hover:text-white">Notarías</Link></li>
      <li><Link to="/talleres" className="hover:text-white">Talleres asociados</Link></li>
      <li><Link to="/automotoras" className="hover:text-white">Para automotoras</Link></li>
    </ul>
  </div>
);
